import { Component } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { GeneralComponent } from './general/general.component';
import { PredictorComponent } from './predictor/predictor.component';
import { DataPropertiesComponent } from './data-properties/data-properties.component';

@Component({
  selector: 'app-model-view',
  standalone: true,
  imports: [MatTabsModule, GeneralComponent, PredictorComponent, DataPropertiesComponent],
  templateUrl: './model-view.component.html',
  styleUrl: './model-view.component.scss'
})
export class ModelViewComponent {
}
